module.exports = __webpack_public_path__ + "media/companies/Infravia-54c0fe9f.png";